import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import { SILENT_ERROR } from '../lib/queryMeta';
import type { AcademicTerm } from '../lib/journal';

/**
 * Choraklar ro'yxati (`GET /academic-terms`) — barcha sahifalar bitta keshni bo'lishadi.
 * `academicYearId` berilmasa backend FAOL o'quv yilining choraklarini qaytaradi.
 *
 * `meta: SILENT_ERROR` — bu LOOKUP so'rovi: uni ishlatadigan joylar (chorak tanlagichi)
 * xatoni O'ZIDA ko'rsatadi yoki eski matnli ro'yxatga qaytadi. Global qizil toast
 * har sahifa ochilganda takrorlanmasin.
 */
export function useAcademicTerms(academicYearId?: string | null, enabled = true) {
  return useQuery({
    queryKey: ['academic-terms', academicYearId ?? 'active'],
    queryFn: async () =>
      (await api.get<AcademicTerm[]>('/academic-terms', {
        params: { academicYearId: academicYearId || undefined },
      })).data,
    enabled,
    meta: SILENT_ERROR,
  });
}

/**
 * Bugungi sanaga tushadigan chorak (`GET /academic-terms/current`).
 * Hech qaysi chorakka tushmasa backend `null` qaytaradi — bu XATO emas
 * (ta'til / yozgi davr), shuning uchun bo'sh javob jimgina qabul qilinadi.
 */
export function useCurrentTerm(enabled = true) {
  return useQuery({
    queryKey: ['academic-term-current'],
    queryFn: async () => (await api.get<AcademicTerm | null>('/academic-terms/current')).data,
    enabled,
    meta: SILENT_ERROR,
  });
}
